/**
 * Widget-picker open state — a tiny external store so the global `` ` `` hotkey
 * (and any surface) can open the picker without prop drilling. The active
 * workspace body owns the dialog and the `addWidget` write path.
 */

import { useSyncExternalStore } from "react";

type Listener = () => void;

let open = false;
const listeners = new Set<Listener>();

function notify(): void {
  for (const listener of listeners) listener();
}

export function subscribeWidgetPicker(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getWidgetPickerOpen(): boolean {
  return open;
}

export function openWidgetPicker(): void {
  if (open) return;
  open = true;
  notify();
}

export function setWidgetPickerOpen(next: boolean): void {
  if (open === next) return;
  open = next;
  notify();
}

/** Subscribe a component to the picker's open state. */
export function useWidgetPickerOpen(): boolean {
  return useSyncExternalStore(
    subscribeWidgetPicker,
    getWidgetPickerOpen,
    getWidgetPickerOpen,
  );
}
